export class Employee {
  id = 0;
  dealerID = 0;
  firstName = null;
  lastName = null;
  email = null;
  authorityLevel = null;
  jobTitle = null;
  loginStatus = null;
}
